export const tokenStorageKey = 'remoteVisitorToken'

export const getVisitorToken = () => {
  const token = window.sessionStorage.getItem(tokenStorageKey)

  return token?.replaceAll(' ', '+')
}